"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbMessageList = void 0;

var _react = _interopRequireDefault(require("react"));

var _map = _interopRequireDefault(require("lodash/map"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _locales = require("../../skybase-core/locales");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This component displays given messages and applies additional props (style, ..).
// eslint-disable-next-line no-underscore-dangle
var _SbMessageList = function _SbMessageList(props) {
  /**
   * @desc
   * Renders given messages.
   *
   * @param {List} messages  - Messages to be displayed.
   * @param {Function} formatMessage - formatMessage function from react-intl.
   * @returns {Array} - Rendered messages.
   */
  var renderMessages = function renderMessages(messages, formatMessage) {
    return (0, _map.default)(messages, function (message, index) {
      var text = message.text,
          messageStyle = message.style,
          messageClassName = message.className,
          messageId = message.id;
      var key = id || "sb-message-list-item_".concat(index);
      var translatedText = (0, _locales.translateMessage)(formatMessage, text);
      return /*#__PURE__*/_react.default.createElement("li", {
        key: key,
        className: (0, _classnames.default)('sb-message', messageClassName),
        id: messageId,
        style: messageStyle
      }, translatedText);
    });
  };

  var messages = props.messages;
  var formatMessage = props.intl.formatMessage,
      id = props.id,
      className = props.className,
      style = props.style; // Kept this conversion to maintain the deprecation for unconverted objects to JS object.

  if (messages.toJS) {
    console.warn('[toJS conversion]: `messages` should be converted with .toJS() before passing to this component.');
    messages = messages.toJS();
  }

  return /*#__PURE__*/_react.default.createElement("ul", {
    id: id,
    className: className,
    style: style
  }, renderMessages(messages, formatMessage));
};

_SbMessageList.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  messages: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.object)]).isRequired,
  style: _propTypes.default.object,
  // eslint-disable-line
  intl: _shapes.intlShape.isRequired
};
_SbMessageList.defaultProps = {
  id: null,
  className: null,
  style: null
};
var SbMessageList = (0, _reactIntl.injectIntl)(_SbMessageList);
exports.SbMessageList = SbMessageList;
//# sourceMappingURL=sb-message-list.js.map